// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationBell_wrapper__ZdRu4","bell":"NotificationBell_bell__GesnZ","badge":"NotificationBell_badge__Cuk5i"};